document.addEventListener('DOMContentLoaded', function () {

    var stForm = document.querySelector('#stress-test-form');
    var stInput = document.querySelector('#sTestUrl');
    var stReset = document.querySelector('#stressProcessReset');
    if(stForm != null) {
        new SwitchableForm(stForm);
    }
    if(stInput != null) {
        new STInput(stInput);
    }
    if(stReset != null) {
        new STForm();
    }
});

/* Stress test form */
var STForm = function () {
    this.stSubmit = document.querySelector('#stressProcessSubmit');
    this.stReset = document.querySelector('#stressProcessReset');
    this.testUrl = document.querySelector('#sTestUrl');
    this.init();
};

STForm.prototype.init = function () {
    var cmp = this;

    cmp.stReset.addEventListener('click', function () {
        cmp.testUrl.value = '';
        cmp.stSubmit.dispatchEvent('click');
    });
}
/* /Stress test form */

/* Stress test input */
var STInput = function (container) {
    this.testUrl = container;
    this.init();
};

STInput.prototype.init = function () {
    var cmp = this;

    cmp.testUrl.addEventListener('focus', function () {
        if(cmp.testUrl.value == '') {
            cmp.testUrl.value = 'http://';
        }
    });
}
/* /Stress test input */

/* Stress test tabs */
var SwitchableForm = function (container) {
    this.container = container;
    this.swicthOn = this.container.querySelector('#htaccess');
    this.switchOff = this.container.querySelector('#public');
    this.switchableBlock = this.container.querySelector('.j-switchable-block');
    this.init();
};

SwitchableForm.prototype.init = function () {
    var cmp = this;

    cmp.swicthOn.addEventListener('change', function () {
        if(cmp.swicthOn.checked) {
            cmp.switchableBlock.classList.remove('_hidden');
        }
    });

    cmp.switchOff.addEventListener('change', function () {
        if(cmp.switchOff.checked) {
            cmp.switchableBlock.classList.add('_hidden');
        }
    });
}
/* /Stress test tabs */
